import $ from "jquery";
const OVERLAY_CLASS = "rml-overlay-modal";
const SUSPENDED_CLASS = "rml-overlay-modal--suspended";
/**
 * Ant Design `<App>` mounts overlays inside the React subtree by default. In the
 * WP media modal the RML tree lives inside `.media-modal`, so MetaBox / settings
 * dialogs must portal to `document.body`.
 */ function getRmlModalStackProps() {
    return {
        getContainer: ()=>document.body,
        wrapClassName: OVERLAY_CLASS,
        rootClassName: OVERLAY_CLASS,
        classNames: {
            mask: OVERLAY_CLASS
        }
    };
}
function resolveRmlOverlayModalRoot(fromElement) {
    const selector = `.${process.env.ANTD_PREFIX}-modal-root.${OVERLAY_CLASS}`;
    if (fromElement) {
        const root = $(fromElement).closest(selector);
        if (root.length) {
            return root;
        }
    }
    return $(`body > ${selector}`);
}
function suspendRmlOverlayModal(fromElement) {
    const modal = resolveRmlOverlayModalRoot(fromElement);
    if (modal.length) {
        modal.addClass(SUSPENDED_CLASS);
    }
}
function resumeRmlOverlayModal(fromElement) {
    const modal = resolveRmlOverlayModalRoot(fromElement);
    if (modal.length) {
        modal.removeClass(SUSPENDED_CLASS);
    }
}
export { getRmlModalStackProps, resolveRmlOverlayModalRoot, resumeRmlOverlayModal, suspendRmlOverlayModal };
